import i18n from '@/lang/index'

export default [
  {
    permission: ['viewDetailData'],
    element: '.driver-item-count',
    popover: {
      title: i18n.t('integration.export_data'),
      description:  i18n.t('public.Open_report_statistics'),
      operate: {
        openMenu: 'count'
      }
    }
  },
  {
    permission: ['viewDetailData'],
    element: '.driver-item-detailData',
    popover: {
      title: i18n.t('integration.export_data'),
      description: i18n.t('public.Open_report_statistics_detail')
    },
    onHighlightStarted (element) {
      element.click()
    }
  },
  {
    permission: ['viewDetailData'],
    element: '.driver-item-carrier-list',
    popover: {
      title: i18n.t('integration.export_data'),
      description: i18n.t('public.select_monitoring_here')
    }
  },
  {
    permission: ['viewDetailData'],
    element: '.m-c-search',
    popover: {
      title: i18n.t('integration.export_data'),
      description: i18n.t('public.set_export_conditions')
    }
  },
  {
    permission: ['viewDetailData'],
    element: '.driver-item-export-data',
    popover: {
      title: i18n.t('integration.export_data'),
      description: i18n.t('public.set_export_go_download'),
      operate: {
        openMenu: 'application'
      }
    }
  },
  {
    permission: ['viewDetailData'],
    element: '.driver-item-download',
    popover: {
      title: i18n.t('integration.export_data'),
      description:  i18n.t('public.download_desc_1')
    },
    onHighlightStarted (element) {
      element.click()
    }
  }
]
